// Page Header
export const pageHeader = {
  title: "Report Settings",
  isEditorView: true,
  buttonLabel: "Save",
};

// Main Section
export const mainInputs = [
  {
    id: "supersetBaseUrl",
    type: "input",
    title: "Reporting Base URL",
    placeholder: "Reporting Base URL",
    focus: true,
  },
  {
    id: "showLegacyReports",
    type: "checkbox",
    title: "Show Legacy Reports",
    placeholder: "Show Legacy Reports",
  },
];

export const reportSections = [
  {
    label: "Customer Reports",
    code: "Customer Reports"
  },
  {
    label: "Financial Reports",
    code: "Financial Reports"
  },
  {
    label: "Inventory Reports",
    code: "Inventory Reports"
  },
  {
    label: "Sales Reports",
    code: "Sales Reports"
  },
  {
    label: "Custom Reports",
    code: "Custom Reports"
  },
];

export const reportConfigSchema = [
  {
    id: "name",
    type: "input",
    title: "Report Name *",
    placeholder: "Report Name",
    focus: true,
  },
    {
      id: "slug",
      type: "input",
      title: "Report Slug *",
      placeholder: "Report Slug",
    },
  {
    id: "section",
    title: "Report Section *",
    type: "select",
    options: reportSections,
  },
  {
    id: "subSection",
    title: "Report Sub Section *",
    type: "input",
    placeholder: "Report Sub Section",
  },
  {
    id: "description",
    type: "input",
    title: "Report Description",
    placeholder: "Report Description",
  },
  {
    id: "legacyReportSlug",
    type: "input",
    title: "Legacy Report Route",
    placeholder: "Legacy Report Route",
  },
  {
    id: "filterByStoreOrOrg",
    type: "checkbox",
    title: "Filter by Store or Organization",
    placeholder: "Filter by Store or Organization",
  },
  {
    id: "filterByTime",
    type: "checkbox",
    title: "Filter by Date Range",
    placeholder: "Filter by Range",
  },
  {
    id: "filterByText",
    type: "checkbox",
    title: "Filter by Text/Batch ID Input",
    placeholder: "Filter by Text Input",
  },
  {
    id: "filterByItemLocation",
    type: "checkbox",
    title: "Filter by Inventory Location",
    placeholder: "Filter by Inventory Location",
  },
  {
    id: "filterByCreditMemoType",
    type: "checkbox",
    title: "Filter by Credit Memo Type",
    placeholder: "Filter by Credit Memo Type",
  },
  {
    id: "filterByItemType",
    type: "checkbox",
    title: "Filter by Cannabis/Non-Cannabis Type",
    placeholder: "Filter by Cannabis/Non-Cannabis Type",
  },
  {
    id: "showOnEndOfDayClosingMenu",
    type: "checkbox",
    title: "Show on End of Day Closing Menu",
    placeholder: "Show on End of Day Closing Menu",
  },
  {
    id: "filterBySaleType",
    type: "checkbox",
    title: "Filter by Medical/Rec (medical stores only)",
    placeholder: "Filter by Medical/Rec (medical stores only)",
  },
  {
    id: "isDFDefault",
    type: "checkbox",
    title: "Is DF Report",
    placeholder: "Is DF Report",
  },
];

export const defaultReportConfig = {
  name: "",
  slug: "",
  legacyReportSlug: "",
  section: "",
  description: "",
  filterByStoreOrOrg: true,
  filterByTime: true,
  filterByText: false,
  filterByRange: false,
  filterByItemLocation: false,
  filterByCustomerLoyalty: false,
  filterByItemType: false,
  filterByCreditMemoType: false,
  isDFDefault: false,
  showOnEndOfDayClosingMenu: false,
  filterBySaleType: false,
};

